import { configureCrispLocked } from "../../utils/crispConfig";

import { useEffect } from "react";

const CrispWeb = () => {
  useEffect(() => {
    const initializeCrisp = async () => {
      try {
        await configureCrispLocked({
          autoload: true,
          lockMaximized: true,
          lockFullview: true
        });
      } catch (error) {
        // Crisp initialization is optional, log and continue
        console.warn('Failed to initialize Crisp chat:', error);
      }
    };
    
    initializeCrisp();
  }, []);

  return <></>;
};

export default CrispWeb;
